if (!customElements.get('flash-sale-countdown')) {
  class FlashSaleCountdown extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate);
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.startCountdown();
    }

    startCountdown() {
      if (!this.endDate) return;

      const updateCountdown = () => {
        const now = new Date();
        const diff = this.endDate - now;

        if (diff <= 0) {
          clearInterval(this.timer);
          this.daysEl.textContent = '00';
          this.hoursEl.textContent = '00';
          this.minutesEl.textContent = '00';
          this.secondsEl.textContent = '00';

          this.style.display = 'none';
          
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      updateCountdown();
      this.timer = setInterval(updateCountdown, 1000);
    }
  }

  customElements.define('flash-sale-countdown', FlashSaleCountdown);
}
